import React, { useEffect } from 'react';

import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import FormLabel from '@mui/material/FormLabel';
import DatePicker from './DatePicker'
import { useForm } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { TitleFont } from '../../../libs/base/base-style';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import { Stack } from '@mui/system';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Checkbox from '@mui/material/Checkbox';
import { useHorsesStore } from '../../../stores/horses'
import Modal from '@mui/material/Modal';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Upload from './Upload';
import { getEventById, getEventByName } from './utils';
type DetailsProps = {
    title: string;
    lastVisit?: string;
    reminder?: string;
    notes?: string;
    event_type: number;
    subtitle?: string;
    actionTitle?: string;
    noReminder?: boolean;
    config?: any
    rename?: string,
    visitId?: string
}

const defaultValues = {
    last_visit: new Date(),
    reminder_date: new Date(),
    notes: '',
    event_type: 0,
    _ID: 0,
};

const style = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    outline: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
};

const ResStack: React.FC<React.PropsWithChildren> = (props) => {
    return <Stack sx={{
        alignItems: { sm: 'center', xs: 'flex-start' },
        flexDirection: {
            xs: 'coloumn',
            sm: 'row'
        },
        width: {
            xs: '100%',
            sm: 'inherit'
        }
    }}>{props.children}</Stack>
}

interface Props extends DetailsProps {
    open: boolean
    close: () => void
}
const App: React.FC<Props> = (props) => {
    const stores = useHorsesStore()
    const { title, event_type } = props//useLocation<DetailsProps>().state;
    const [checked, setChecked] = React.useState(false);
    const [file, setFiles] = React.useState<{ name: string; url: string }>();
    const theme = useTheme()
    const matches = useMediaQuery(theme.breakpoints.down('sm'));
    const handleCheck = (event: React.ChangeEvent<HTMLInputElement>, value: boolean) => {
        console.log(value)
        setChecked(value);
    };

    const methods = useForm({
        defaultValues:
            stores.currentActions?.action == 'edit' ? stores.visits.find(item => {
                return item._ID == stores.currentActions?.id
            }) : { last_visit: Date.now(), reminder_date: Date.now(), notes: '', video_url: '' }
    });
    const { handleSubmit, reset, control, setValue } = methods;
    const create = async (data) => {
        await stores.add({
            ...data,
            reminder_date: checked == true ? data.reminder_date : '0',
            horse_id: stores.currentActions?.id,
            event_type: String(event_type)
        }).then(res => {
            if (res.success) {
                if (file?.name && file.url && stores.currentActions?.id) {
                    addfile({ event_type: String(event_type), ...file, profile_id: stores.currentActions?.id, visit_id: String(res.item_id) })
                }

                props.close()
            }
        })

    }
    const update = (data) => {
        if (stores.visits.find(item => item._ID == stores.currentActions?.id)) {
            stores.update({
                ...data,
                reminder_date: checked == true ? data.reminder_date : '0',
                video_url: data.video_url ? data.video_url : '',
                _ID: stores.currentActions?.id,
                event_type: String(event_type)
            }).then(res => {
                if (res.success) {
                    props.close()
                }
            })
        } else {
            props.close()
        }
    }
    const addfile = async (value: { name: string, url: string, profile_id: string, event_type: string, visit_id: string }) => {
        if (value.url && value.name) {
            await stores.addFile({
                ...value
            })
            setFiles(undefined);
        }

    }
    // const onSubmit = (data) => {
    //     if (stores.visits.find(item => item._ID == stores.currentActions?.id)) {
    //         stores.update({
    //             ...data,
    //             video_url: data.video_url ? data.video_url : '',
    //             _ID: stores.currentActions?.id,
    //             event_type: String(event_type)
    //         }).then(res => {
    //             if (res.success) {
    //                 props.close()
    //             }
    //         })
    //     } else {//add new
    //         stores.add({
    //             ...data,
    //             horse_id: stores.currentActions?.id,
    //             event_type: String(event_type)
    //         }).then(res => {
    //             if (res.success) {
    //                 props.close()
    //             }
    //         })
    //     }
    // }

    useEffect(() => {
        console.log(props.config)
        if (stores.currentActions?.action == 'edit') {
            const visit = stores.visits.find(item => item._ID == stores.currentActions?.id)
            visit && methods.reset(visit)
        } else {
            console.log(stores.currentActions?.action)
            methods.reset(undefined)
        }
        if (props.open == false) {
            reset({ last_visit: Date.now(), reminder_date: Date.now(), notes: '', })
        }
    }, [props.open])
    return <Modal
        open={props.open}
        onClose={() => {
            reset({ last_visit: Date.now(), reminder_date: Date.now(), notes: '', })
            props.close()
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
    >
        <Container sx={style}>
            <Box >
                <FormControl>
                    <Grid container spacing={2}>
                        <StyledGrid item xs={12} sm={12} mb={5}>
                            <VisitTitle>{props.rename ? props.rename : `${title} Records:`}</VisitTitle>
                        </StyledGrid>

                        <StyledGrid item xs={12} sm={6}>

                            <ResStack>
                                <StyledGrid item sx={{
                                    width: { sm: 250 }
                                }} xs={12} >
                                    <StyleFormLabel >{props.subtitle ? props.subtitle : `Last ${title} Visit:`}</StyleFormLabel>
                                </StyledGrid>

                                <Stack direction="row" alignItems={'flex-start'} width={matches == true ? '100%' : 200}>
                                    <DatePicker control={control} name={'last_visit'} width={matches == true ? undefined : 200} />

                                </Stack>


                            </ResStack>

                        </StyledGrid>
                        <StyledGrid item xs={12} sm={6}>
                            {props.noReminder === true ? null : <ResStack>
                                <StyledGrid item sx={{
                                    width: { sm: 270 }
                                }} xs={12} >
                                    <Checkbox
                                        checked={checked}
                                        onChange={handleCheck}

                                        sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }, '& .PrivateSwitchBase-input': { width: '100%' } }}
                                    />
                                    {props.config?.reminderLable ? <StyleFormLabel>{props.config?.reminderLable}</StyleFormLabel> : <StyleFormLabel>{`${title} Reminder:`}</StyleFormLabel>}
                                </StyledGrid>
                                <Stack direction="row" alignItems={'flex-start'} width={matches == true ? '100%' : 200}>

                                    <DatePicker control={control} name={'reminder_date'} width={matches == true ? undefined : 200} canEdit={checked} />

                                </Stack>
                            </ResStack>}



                        </StyledGrid>

                        {props.config?.videoTextfield === true ?
                            <StyledGrid item xs={12} sm={12}>
                                <Controller
                                    rules={{ required: false }}
                                    control={control}
                                    name={'video_url'}
                                    render={({ field, fieldState: { error } }) => (
                                        <Grid container>
                                            <StyledGrid item sx={{
                                                width: { sm: 250 }
                                            }} xs={12} >
                                                {props.config?.videoTextLabel ? <StyleFormLabel>{props.config?.videoTextLabel}</StyleFormLabel> : <StyleFormLabel>{`Video:`}</StyleFormLabel>}
                                            </StyledGrid>
                                            <StyledGrid item xs={12} sm>
                                                <Stack direction="column" alignItems={'flex-start'} sx={{ width: '100%' }} spacing={2}>
                                                    <TextField
                                                        placeholder='Input here...'
                                                        sx={{ width: '100%' }}
                                                        InputProps={{ sx: { borderRadius: 0 } }}
                                                        {...field}
                                                        style={{ textAlign: 'start' }}
                                                        error={error !== undefined} helperText={error ? 'This is required' : ''}
                                                    />
                                                </Stack>
                                            </StyledGrid>
                                        </Grid>
                                    )}
                                />
                            </StyledGrid> : null
                        }
                        <StyledGrid item xs={12} sm={12}>
                            <StyleFormLabel>Upload files: </StyleFormLabel>
                            <Upload customField={{ event_type: String(props.event_type), visit_id: String(stores.currentActions?.id) }} visitId={String(stores.currentActions?.id)}
                                completeHandle={(response) => setFiles({ name: response.name, url: response.fileUrl })}
                            />
                        </StyledGrid>

                        <StyledGrid item xs={12} mt={5}>
                            <Controller
                                rules={{ required: false }}
                                control={control}
                                name={'notes'}
                                render={({ field, fieldState: { error } }) => (
                                    <Grid container>
                                        <StyledGrid item sx={{
                                            width: { sm: 250 }
                                        }} xs={12} >
                                            {props.config?.renameNotes ? <StyleFormLabel> {props.config?.renameNotes} </StyleFormLabel> : <StyleFormLabel>Notes: </StyleFormLabel>}
                                        </StyledGrid>
                                        <StyledGrid item sm xs={12}>
                                            <Stack direction="column" alignItems={'flex-start'} sx={{ width: '100%' }} spacing={2}>
                                                <TextField
                                                    placeholder='Start typing your notes…'
                                                    multiline
                                                    maxRows={6}
                                                    sx={{ width: '100%' }}
                                                    InputProps={{ sx: { height: 90, borderRadius: 0 } }}
                                                    {...field}
                                                    style={{ textAlign: 'start' }}
                                                    error={error !== undefined} helperText={error ? 'Notes is required' : ''}
                                                />
                                                <Stack direction="row" alignItems={'flex-start'} sx={{ width: '100%' }} spacing={2}>
                                                    {stores.currentActions?.action == 'edit' ?
                                                        <Btn variant='contained' onClick={handleSubmit(update, (err) => {
                                                            console.log('erro', err)
                                                        })}>Save Changes</Btn> :
                                                        <Btn variant='contained' onClick={handleSubmit(create, (err) => {
                                                            console.log('erro', err)
                                                        })}>{props.actionTitle ? props.actionTitle : 'Add Visit'}</Btn>
                                                    }

                                                    <SecBtn variant='text' endIcon={<ArrowForwardIosIcon sx={{ width: 12 }} />} onClick={props.close}>Close</SecBtn>
                                                </Stack>

                                            </Stack>
                                        </StyledGrid>

                                    </Grid>
                                )}
                            />
                        </StyledGrid>

                    </Grid>
                </FormControl>
            </Box>

        </Container></Modal>
}

const StyledBtn = styled(Button)`
    background-color: transparent !important;
    color:#408697 !important;
    font-size: 11px !important;
    text-transform: none !important;
    padding:0 !important;
    font-family: sans-serif;

`
const TextBtn = styled(StyledBtn)`
    font-size: 14px !important;
    padding:5px 25px !important;
`
const FillBtn = styled(Button)`
    color:white !important;
    font-size: 14px !important;
    border-radius:0 !important;
    padding:5px 25px !important;
    font-family: sans-serif;
`

const Btn = styled(FillBtn)(({ theme }) => ({
    '&:hover': {
        backgroundColor: '#408697'
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '1rem !important',
    },
    backgroundColor: '#408697'
}));
const SecBtn = styled(TextBtn)(({ theme }) => ({
    [theme.breakpoints.down('sm')]: {
        fontSize: '1rem !important',

    },
}));

const Title = styled(TitleFont)`
    font-size: 35px;
    margin: 20px;
    font-weight: 800;
    font-family: inherit;

`
const VisitTitle = styled(Title)`
    margin:0;
   
`
const SubTitle = styled(VisitTitle)`
    font-size:25px;
    margin-top:40px;
    margin-bottom:40px;
`
const StyledGrid = styled(Grid)`
    text-align:center;
    display: flex;
    align-items: center;
    justify-content: flex-start;
`

const StyleFormLabel = styled(FormLabel)`
    font-weight: 400 !important;
    color:#000 !important;
    font-size:20px !important;
    margin-right:20px !important;
    font-family: inherit !important;
    width:250px;
    margin-bottom:5px;
`


export default App;